import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'idp-alert-warning',
  templateUrl: './alert-warning.component.html',
  styleUrls: ['./alert-warning.component.scss']
})
export class AlertWarningComponent {
  @Input() cntError = 0;
  @Input() customClass = '';
  @Input() errorMessage = '';
  @Input() firstErrorneousElement!: HTMLElement;
  @Input() role = 'alert';
  @Input() topBorder = false;
  @Input() tabIndex = 0;
  @Input() isWarning = false;
  @Output() firstInvalidFieldFocusEvent: EventEmitter<void> =
    new EventEmitter();

  @ViewChild('alertWarningBanner') banner!: ElementRef;

  focusFirstInvalidField() {
    if (this.firstErrorneousElement) {
      this.firstErrorneousElement.focus();
    }
    this.firstInvalidFieldFocusEvent.emit();
  }

  /*
    Add class names to the alert component. If the topBorder flag is 'true', the 'idp-alert--red__border' class is added. Else only the standard class names are added
   */
  setClassNames() {
    return this.topBorder
      ? `idp-alert idp-alert-info ${this.customClass} idp-alert--red__border`
      : `idp-alert idp-alert-info ${this.customClass}`;
  }
}
